import React from "react";
import TextField from "@mui/material/TextField";
import { useIsMobile } from "../../Hooks";
import { useTranslation } from "react-i18next";
import { calculateSavedNutrients as calc } from "../../Utils/CalculateHelper";

import useStyles from "./FmNutrientsTable.style";
import { nutrients, ZERO, FIVE, TWO, ONE } from "../../Utils/Consts";
import { FarmerPracticeViewModel } from "../../Models";
import { useSelector } from "react-redux";
import { GeneralState } from "../../Redux";
import { SMALL_MESURMENT_UNIT } from "../../Constants";

interface FmNutrientsTableProps {
    inputsArray?: any;
    cropDemand: FarmerPracticeViewModel[];
}

const FmNutrientsTable = ({ inputsArray, cropDemand }: FmNutrientsTableProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    const { activeMetricMethod } = useSelector(GeneralState.Selectors.selectMetricMethods);
    const valueSelected = Number(activeMetricMethod) == ONE ? ZERO : ONE;
    return (
        <div className={classes.container}>
            <div className={isMobile ? classes.mobile_titles_container : classes.titles_container}>
                <div className={classes.titles_leftSide}>
                    <div className={isMobile ? classes.mobile_nutrientsTitle : classes.nutrientsTitle}>
                        {t("pageStep4.table.nutrients")}
                        <span className={classes.smallLetters}>({(SMALL_MESURMENT_UNIT as any)[activeMetricMethod]})</span>
                    </div>
                </div>

                <div className={classes.titles_rightSide}>
                    <span className={classes.bigRatioContainerWithTextAlignToLeft}>{nutrients.n}</span>
                    <span className={classes.bigRatioContainerWithTextAlignToLeft}>
                        {nutrients.p}
                        <span className={classes.smallestLetters}>{TWO}</span>
                        {ZERO}
                        <span className={classes.smallestLetters}>{FIVE}</span>
                    </span>
                    <span className={classes.smallRatioContainerWithTextAlignToLeft}>
                        {nutrients.k}
                        <span className={classes.smallestLetters}>{TWO}</span>
                        {ZERO}
                    </span>
                </div>
            </div>
            <div className={classes.table_container}>
                <div className={isMobile ? classes.mobile_tableLeftSide : classes.tableLeftSide}>
                    <span className={classes.titleSmallWidth}>{t("pageStep4.table.label1")}</span>
                    <span className={classes.titleSmallWidth}>{t("pageStep4.table.label2")}</span>
                    <span className={isMobile ? classes.titleSmallWidth : classes.titleWidth}>{t("pageStep4.table.label3")}</span>
                </div>

                <div className={isMobile ? classes.mobile_tableRightSide : classes.tableRightSide}>
                    <div className={isMobile ? classes.mobile_rightSide_firstRow : classes.rightSide_firstRow}>
                        <TextField
                            id='standard-basic'
                            variant='standard'
                            type='number'
                            placeholder='0'
                            inputProps={{ style: { textAlign: "left" } }}
                            value={inputsArray[0].input}
                            onChange={(e) => inputsArray[0].setInput(e.target.value)}
                            className={isMobile ? classes.inputSmallWidth : classes.inputWideWidth}
                        />

                        <TextField
                            id='standard-basic'
                            variant='standard'
                            type='number'
                            placeholder='0'
                            inputProps={{ style: { textAlign: "left" } }}
                            value={inputsArray[2].input}
                            onChange={(e) => inputsArray[2].setInput(e.target.value)}
                            className={isMobile ? classes.inputSmallWidth : classes.inputWideWidth}
                        />
                        <TextField
                            id='standard-basic'
                            variant='standard'
                            type='number'
                            placeholder='0'
                            inputProps={{ style: { textAlign: "left" } }}
                            value={inputsArray[1].input}
                            onChange={(e) => inputsArray[1].setInput(e.target.value)}
                            className={isMobile ? classes.inputSmallWidth : classes.inputWideWidth}
                        />
                    </div>
                    <div className={classes.rightSide_secondRow}>
                        <span className={classes.bigRatioContainerWithTextAlignToLeft}>{cropDemand[valueSelected].cropDemand.n}</span>
                        <span className={classes.bigRatioContainerWithTextAlignToLeft}>{cropDemand[valueSelected].cropDemand.p}</span>
                        <span className={classes.smallRatioContainerWithTextAlignToLeft}>{cropDemand[valueSelected].cropDemand.k}</span>
                    </div>
                    <div className={isMobile ? classes.mobile_rightSide_thirdRow : classes.rightSide_thirdRow}>
                        <span className={classes.bigRatioContainerWithTextAlignToLeft}>
                            {calc(inputsArray[0].input, cropDemand[valueSelected].cropDemand.n)}
                        </span>
                        <span className={classes.bigRatioContainerWithTextAlignToLeft}>
                            {calc(inputsArray[2].input, cropDemand[valueSelected].cropDemand.p)}
                        </span>
                        <span className={classes.smallRatioContainerWithTextAlignToLeft}>
                            {calc(inputsArray[1].input, cropDemand[valueSelected].cropDemand.k)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FmNutrientsTable;
